const DisconnectedIcon = ({ stroke = "currentColor", className = "" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
    className={className}
  >
    <path
      d="M48.0439 13.3334C52.7592 18.1434 55.6667 24.7322 55.6667 32.0001C55.6667 39.3543 52.6897 46.0131 47.8751 50.8373M10.3334 51.0439C5.39641 46.2041 2.33337 39.4598 2.33337 32.0001C2.33337 24.6267 5.32595 17.9522 10.1628 13.125"
      stroke={stroke}
      strokeOpacity="0.6"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M40.4263 21.4512C43.2555 24.1574 45 27.8642 45 31.9532C45 36.0907 43.2138 39.837 40.3251 42.5511M17.8 42.6673C14.8378 39.9444 13 36.1501 13 31.9532C13 27.8049 14.7955 24.0498 17.6976 21.334"
      stroke={stroke}
      strokeOpacity="0.6"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="29" cy="31.9993" r="5.33333" stroke={stroke} strokeOpacity="0.6" strokeWidth="3" />
  </svg>
);

export default DisconnectedIcon;
